<template>
  <div>

    <b-form-group>
      <label :for="id">{{ label }}</label>
      <validation-provider
        #default="{ errors }"
        :name="errorName"
        :rules="rules"
      >
        <div class="d-flex align-items-center">
          <b-form-textarea
            :id="id"
            v-model="innerValue"
            :value="value"
            :placeholder="placeholder"
            :state="errors.length > 0 ? false:null"
            :rows="rows"
            :maxlength="maxlength"
            :readonly="readonly"
            @input="onInput"
            @keypress.native="handleKeyPress"
          />
          <feather-icon
            v-show="showIcon"
            :icon="icon"
            :size="iconSize"
            class="cursor-pointer ml-1"
            @click="onClick"
          />
        </div>
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

  </div>
</template>

<script>
import { BFormGroup, BFormTextarea } from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate'
import { persistPhoneNumber, persistAccountNumber } from '../../helpers/handleSpecialCharacter'

export default {
  name: 'TextAreaField',
  components: {
    BFormGroup,
    BFormTextarea,
    ValidationProvider,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    errorName: {
      type: String,
      default: 'default',
    },
    value: {
      type: null,
      default: '',
    },
    rules: {
      type: [Object, String],
      default: '',
    },
    rows: {
      type: String,
      required: true,
      default: '4',
    },
    id: {
      type: String,
      required: true,
    },
    readonly: {
      type: Boolean,
      required: false,
    },
    icon: {
      type: String,
      default: 'AlertCircleIcon',
      required: false,
    },
    iconSize: {
      type: String,
      default: '16',
      required: false,
    },
    showIcon: {
      type: Boolean,
      default: false,
      required: false,
    },
    onClick: {
      type: Function,
      default: () => {},
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: null,
    },
    maxlength: {
      type: String,
      required: false,
      default: '',
    },
    onInput: {
      type: [Function, Number, String],
      default: () => {},
      required: false,
    },
    isAllowNumbersWithComma: {
      type: Boolean,
      default: true,
      required: false,
    },
    isAllowAccountNumbersWithComma: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  data() {
    return {
      innerValue: '',
    }
  },
  computed: {
    hasValue() {
      return !!this.innerValue
    },
  },
  watch: {
    innerValue(value) {
      this.$emit('input', value)
    },
    value(val) {
      if (val !== this.innerValue) {
        this.innerValue = val
      }
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value
    }
  },
  methods: {
    handleKeyPress(event) {
      if (!this.isAllowNumbersWithComma) {
        persistPhoneNumber(event)
      }
      if (!this.isAllowAccountNumbersWithComma) {
        persistAccountNumber(event)
      }
    },
  },
}

</script>
